import {AnimatePresence, motion} from 'framer-motion';

import {useState} from 'react';

import {isNil} from 'ramda';

import {EmailCredentialsOwnerType, SmtpEmailProviderResponseBody} from '@dms/api/core';

import {useHandleSelectOAuthProvider} from '../hooks/useHandleSelectOAuthProvider';
import {EmailServiceProvider} from '../types/EmailServiceProvider';
import {EmailServiceForm} from './EmailServiceForm';
import {ServiceProviders} from './ServiceProviders';

interface CreateEmailServiceProviderProps {
  ownerType: EmailCredentialsOwnerType;
}

export function CreateEmailServiceProvider(props: CreateEmailServiceProviderProps) {
  const [handleSelectOAuthProvider] = useHandleSelectOAuthProvider({
    ownerType: props.ownerType,
    purpose: 'email',
  });
  const [selectedProvider, setSelectedProvider] = useState<SmtpEmailProviderResponseBody | null>(
    null
  );

  const handleProviderSelect = (
    provider: EmailServiceProvider,
    startLoading: () => void,
    stopLoading: () => void
  ) => {
    if (provider.code === 'microsoft-oauth') {
      handleSelectOAuthProvider(startLoading, stopLoading);
      return;
    }

    setSelectedProvider(provider);
  };

  return (
    <AnimatePresence mode="wait">
      {isNil(selectedProvider) ? (
        <motion.div
          key="service-providers"
          initial={{height: 0, opacity: 0}}
          animate={{height: 'auto', opacity: 1}}
          exit={{height: 0, opacity: 0}}
          transition={{duration: 0.3}}
        >
          <ServiceProviders onSelect={handleProviderSelect} />
        </motion.div>
      ) : (
        <motion.div
          key="empty-box"
          initial={{height: 0, opacity: 0}}
          animate={{height: 'auto', opacity: 1}}
          exit={{height: 0, opacity: 0}}
          transition={{duration: 0.3}}
        >
          <EmailServiceForm
            onChangeProvider={() => setSelectedProvider(null)}
            providerCode={selectedProvider.code}
            defaultValues={{
              emailAddress: selectedProvider.credentials?.emailAddress ?? undefined,
              host: selectedProvider.credentials?.host ?? undefined,
              port: selectedProvider.credentials?.port ?? undefined,
              username: selectedProvider.credentials?.username ?? undefined,
              password: selectedProvider.credentials?.password ?? undefined,
            }}
            ownerType={props.ownerType}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
